export enum StatusEnum {
	reject = 'reject',
	accept = 'accept',
	pending = 'pending',
}

export interface CreateBannerDto {
	id?: number;
	fileId: number;
	userId: number;
	passportId: number;
	placeId: number;
	status?: string;
	statusMrkt?: string;
	statusAccnt?: string;
	comment?: string;
	commentMrkt?: string;
	commentAccnt?: string;
	isDeviceGallery?: boolean;
	lat: string;
	lon: string;
	photoAt?: Date;
	posted?: boolean;
	idempotencyKey?: string;
}
